import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "home"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "topbg"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top = _resolveComponent("top");

  const _component_usermenu = _resolveComponent("usermenu");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_top, {
    ref: "top",
    onChange_color: $options.change_color
  }, null, 8, ["onChange_color"]), _createVNode(_component_usermenu, {
    ref: "usermenu",
    onGet_balance: _cache[0] || (_cache[0] = $event => _ctx.$refs['top'].get_balance())
  }, null, 512), _createVNode(_component_router_view, {
    class: "router-view-main",
    onChange_submenu: $options.change_submenu,
    onChange_play: $options.change_play,
    onChange_game_list: _cache[1] || (_cache[1] = $event => _ctx.$refs['usermenu'].get_game_list())
  }, null, 8, ["onChange_submenu", "onChange_play"])]);
}